"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./Rowselectheader.module.css";

// const _interactionsData = JSON.parse(
//   '{"events":{"e-977":{"id":"e-977","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-62","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-978"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0d860697-eae6-95c8-87f3-26a9a1348f9f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0d860697-eae6-95c8-87f3-26a9a1348f9f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721226291188},"e-978":{"id":"e-978","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-63","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-977"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0d860697-eae6-95c8-87f3-26a9a1348f9f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0d860697-eae6-95c8-87f3-26a9a1348f9f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721226291188}},"actionLists":{"a-62":{"id":"a-62","title":"contact info [show] 2","actionItemGroups":[{"actionItems":[{"id":"a-62-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".leadinfo_section","selectorGuids":["ec089049-5221-df34-2029-a531d6682be0"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701793989695},"a-63":{"id":"a-63","title":"contact info [hide] 2","actionItemGroups":[{"actionItems":[{"id":"a-63-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".leadinfo_section","selectorGuids":["ec089049-5221-df34-2029-a531d6682be0"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701794010668}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
// );

export function Rowselectheader({
  as: _Component = _Builtin.Block,
  position = "Director",
  organization = "ABC Organization",
  website = "https://abc.org/",
  address = "5400 Phoenix Ave NE Suite 105",
  city = "ABQ",
  contact = "5052654777",
  status = "Signed up, Prospect, Waiting",
  name = "Albert Flores",
  isChecked = false,
  onCheckboxChange = () => { },
}) {
  // _interactions.useInteractions(_interactionsData, _styles);

  const handleCheckboxChange = (e) => {
    onCheckboxChange(e.target.checked);
  };
  return (
    <div className="tablerow selectheaderrow">
      <div className="tablecell _w-auto">
        <label className="checkbox-field w-checkbox">
          <div className={`w-checkbox-input w-checkbox-input--inputType-custom checkbox w-checkbox-input ${isChecked ? "w--redirected-checked" : ""}`} />
          <input
            // form="[object Object]"
            checked={isChecked}
            onChange={handleCheckboxChange}
            type="checkbox"
            defaultChecked=""
            style={{ opacity: 0, position: "absolute", zIndex: -1 }}
          />
          <span className="checkbox-label w-form-label">Checkbox</span>
        </label>
      </div>
      <div className="tablecell">
        <div>{name}</div>
      </div>
    </div>
    // <_Component
    //   className={_utils.cx(_styles, "tablerow", "selectheaderrow")}
    //   // data-w-id="0d860697-eae6-95c8-87f3-26a9a1348f9f"
    //   tag="div"
    // >
    //   <_Builtin.Block
    //     className={_utils.cx(_styles, "tablecell", "_w-auto")}
    //     tag="div"
    //   >
    //     <_Builtin.FormCheckboxWrapper
    //       className={_utils.cx(_styles, "checkbox-field")}
    //     >
    //       <_Builtin.FormCheckboxInput
    //         className={`w-checkbox-input w-checkbox-input--inputType-custom checkbox ${isChecked ? "w--redirected-checked" : ""}`}
    //         type="checkbox"
    //         // name="checkbox-2"
    //         // data-name="Checkbox 2"
    //         required={false}
    //         // id="checkbox-2"
    //         checked={isChecked}
    //         onChange={handleCheckboxChange}
    //         form={{
    //           // type: "checkbox-input",
    //           // name: "Checkbox 2",
    //         }}
    //         inputType="custom"
    //       // customClassName="w-checkbox-input--inputType-custom"
    //       />
    //       <_Builtin.FormInlineLabel
    //         className={_utils.cx(_styles, "checkbox-label")}
    //       >
    //         {"Checkbox"}
    //       </_Builtin.FormInlineLabel>
    //     </_Builtin.FormCheckboxWrapper>
    //   </_Builtin.Block>
    //   <_Builtin.Block className={_utils.cx(_styles, "tablecell")} tag="div">
    //     <_Builtin.Block tag="div">{name}</_Builtin.Block>
    //   </_Builtin.Block>
    // </_Component>
  );
}
